<template>
	<div class="row">
		<base-input class="col-md-12"
			v-model="value.inn"
			type="text"
			:name="errorLabel"
			:error="getError(errorLabel)"
			:placeholder="placeholder"
			v-validate="{inn:true}"
		>
			<template v-slot:addonRight>
				<base-button @click="SearchINN()" simple icon type="primary">
					<i class="tim-icons icon-double-right"></i>
				</base-button>
			</template>
		</base-input>
		<label class="col-form-label col-md-12 formRequired"> <span>Название</span> </label>
		<div class="col-md-12">
			<div class="form-group">
				<div class="mb-0">
					<input type="text" placeholder="Название" class="form-control" v-model="value.name">
				</div>
			</div>
		</div>
		<label class="col-form-label col-md-12" ><span>КПП</span></label>
		<div class="col-md-12">
			<div class="form-group">
				<div class="mb-0">
					<input type="number" placeholder="КПП" class="form-control" v-model="value.kpp">
				</div>
			</div>
		</div>
		<label class="col-form-label col-md-12" ><span>ОКПО</span></label>
		<div class="col-md-12">
			<div class="form-group">
				<div class="mb-0">
					<input type="number" placeholder="ОКПО" class="form-control" v-model="value.okpo">
				</div>
			</div>
		</div>
		<label class="col-form-label col-md-12" ><span>ОГРН</span></label>
		<div class="col-md-12">
			<div class="form-group">
				<div class="mb-0">
					<input type="number" placeholder="ОГРН" class="form-control" v-model="value.ogrn">
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'ReInputINNUr',
		components: {

		},
		props: {
			value: {
				type: Object,
				default: function(){return {
					inn:'',
					name:'',
					kpp:'',
					okpo: '',
					ogrn: ''
				}}
			},
			findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: String,
				default: '',
			},
			errorLabel: {
                String,
                default:'ИНН',
            },
			placeholder: {
				type: String,
				default: '',
			},
		},
		data () {
			return {
				ver: 1,
				dmpObject:{
					inn:'',
					name:'',
					kpp:'',
					okpo: '',
					ogrn: ''
				},
			}
		},
		watch:{

		},
		computed: {

		},
		methods: {
			getError(fieldName) {
				return this.errors.first(fieldName);
			},
			SearchINN(){
				if(this.value.inn != '' && typeof this.getError(this.errorLabel)=='undefined'){
					this.$GVO.ApiCall('GET_URINFO_BY_INN',{obj:'client',flt:{inn:this.value.inn}})
					.then((objApi) => {
						if(objApi.success === true && typeof objApi.data.suggestions != 'undefined' && objApi.data.suggestions.length>0){
							//console.log('SearchINN',objApi.data.suggestions[0]);
							this.value.name = objApi.data.suggestions[0].value;

							if(typeof objApi.data.suggestions[0].data.kpp != 'undefined' && objApi.data.suggestions[0].data.kpp != null)
								this.value.kpp = objApi.data.suggestions[0].data.kpp;
							
							if(typeof objApi.data.suggestions[0].data.okpo != 'undefined' && objApi.data.suggestions[0].data.okpo != null)
								this.value.okpo = objApi.data.suggestions[0].data.okpo;
							
							if(typeof objApi.data.suggestions[0].data.ogrn != 'undefined' && objApi.data.suggestions[0].data.ogrn != null)
								this.value.ogrn = objApi.data.suggestions[0].data.ogrn;
						}
					}).catch(errorObjApi => console.error(errorObjApi));
				}
			}
		},
		mounted() {

		}
	}
</script>
<style scoped>
	.btn.btn-icon.btn-simple{margin: 0px;}
</style>
